const LOCALSTORAGE_NOM_USUARIO = 'usuario'
const LOCALSTORAGE_COD_USUARIO = 'coduser'
const LOCALSTORAGE_STATE_USUARIO = 'state.usuario'

export const setUsuario = (state, usuario) => {
  localStorage.setItem(LOCALSTORAGE_COD_USUARIO, usuario.codUsuario + '')
  localStorage.setItem(LOCALSTORAGE_NOM_USUARIO, usuario.nomUsuario)
  localStorage.setItem(LOCALSTORAGE_STATE_USUARIO, JSON.stringify(usuario))

  state.usuario = usuario
}

export const setUsuarioAcesso = (state, acessos) => {
  state.usuario.acessos = acessos
}
